var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4545 16C12.5992 16 12.7379 15.9448 12.8402 15.8467C12.9425 15.7486 13 15.6155 13 15.4767V4.31395C13 4.17518 12.9425 4.0421 12.8402 3.94397C12.7379 3.84585 12.5992 3.79071 12.4545 3.7907H10.0909V1.52326C10.0909 1.38448 10.0334 1.2514 9.93113 1.15328C9.82884 1.05515 9.69011 1.00001 9.54545 1H1.54545C1.4008 1.00001 1.26207 1.05515 1.15978 1.15328C1.05749 1.2514 1.00001 1.38448 1 1.52326V12.686C1.00001 12.8248 1.05749 12.9579 1.15978 13.056C1.26207 13.1542 1.4008 13.2093 1.54545 13.2093H3.90909V15.4767C3.90911 15.6155 3.96658 15.7486 4.06887 15.8467C4.17116 15.9448 4.30989 16 4.45455 16H12.4545ZM11.9091 14.9535H5V4.83721H11.9091V14.9535ZM3.90909 12.1628H2.09091V2.04651H9V3.7907H4.45455C4.30989 3.79071 4.17116 3.84585 4.06887 3.94397C3.96658 4.0421 3.90911 4.17518 3.90909 4.31395V12.1628Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.21320d5657e34f03462e9e024ac69fb2.svg";
export { ForwardRef as ReactComponent };